module.exports = __webpack_public_path__ + "img/getCoupons_bg.719bd5cd.png";